import arrayMoveMutable from "./arrayMoveMutable";

export default function arrayMoveImmutable(array, fromIndex, toIndex) {
  array = [...array];

  arrayMoveMutable(array, fromIndex, toIndex);

  return array;
}
